import { Currency } from "../../../utils/Currency";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);
export class StaticAllocation {
    _principal;
    _interest;
    _fees;
    _prepayment;
    jsPrincipal;
    jsInterest;
    jsFees;
    jsPrepayment;
    constructor(params) {
        this.principal = params.principal;
        this.interest = params.interest;
        this.fees = params.fees;
        this.prepayment = params.prepayment;
        this.updateJsValues();
    }
    get principal() {
        return this._principal;
    }
    set principal(value) {
        if (value instanceof Currency) {
            this._principal = value;
        }
        else {
            this._principal = new Currency(value);
        }
    }
    get interest() {
        return this._interest;
    }
    set interest(value) {
        if (value instanceof Currency) {
            this._interest = value;
        }
        else {
            this._interest = new Currency(value);
        }
    }
    get fees() {
        return this._fees;
    }
    set fees(value) {
        if (value instanceof Currency) {
            this._fees = value;
        }
        else {
            this._fees = new Currency(value);
        }
    }
    get prepayment() {
        return this._prepayment;
    }
    set prepayment(value) {
        if (value instanceof Currency) {
            this._prepayment = value;
        }
        else {
            this._prepayment = new Currency(value);
        }
    }
    get json() {
        return {
            principal: this.principal.toNumber(),
            interest: this.interest.toNumber(),
            fees: this.fees.toNumber(),
            prepayment: this.prepayment.toNumber(),
        };
    }
    updateJsValues() {
        this.jsPrincipal = this.principal.toNumber();
        this.jsInterest = this.interest.toNumber();
        this.jsFees = this.fees.toNumber();
        this.jsPrepayment = this.prepayment.toNumber();
    }
    updateModelValues() {
        this.principal = this.jsPrincipal;
        this.interest = this.jsInterest;
        this.fees = this.jsFees;
        this.prepayment = this.jsPrepayment;
    }
    toCode() {
        return `new StaticAllocation(${JSON.stringify(this.json)})`;
    }
}
